import "./HomePage.css";
import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SearchResults from "./components/SearchResults";
import CourseList from "./components/CourseList";
import FAQ from "./components/FAQ";
import Stats from "./components/Stats";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCourses } from "../../actions/courses";
import AddEditCourse from "../Edit2/AddCourseForm/AddEditCourse";

export default function HomePage() {
  const user = JSON.parse(localStorage.getItem("profile"));
  const [newCourseFormVisible, setNewCourseFormVisible] = useState(false);
  const courses = useSelector((state) =>
    state.CoursesReducer.courses
      .filter((e) => {
        return user?.result?.admin || e.public;
      })
      .sort((a, b) => a.priority - b.priority),
  );
  const isLoading = useSelector((state) => state.CoursesReducer.isLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Calls function which loads courses and puts them in the redux state
  useEffect(() => {
    const ALL_COURSES = -1;
    dispatch(getCourses(ALL_COURSES));
  }, [dispatch]);

  // My courses are the subset of courses that are noted as being taken in user reducer
  const coursesTaken = user?.result?.coursesTaken;
  const myCourses = courses?.filter((course) => {
    return coursesTaken?.some((courseTaken) => {
      return courseTaken.courseID === course._id;
    });
  });

  // ML Courses
  const MLCourses = courses?.filter((course) => {
    return course.title?.includes("Machine Learning");
  });
  const ProbCourses = courses?.filter((course) => {
    return course.title?.includes("Probability");
  });
  const OptimizationCourses = courses?.filter((course) => {
    return course.title?.includes("SAT Solvers");
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState("");
  const heroRef = useRef(null);

  const handleSearch = (tag) => {
    const q = tag.toLowerCase();
    const results = courses.filter(
      (c) =>
        c.tags?.some((t) => t.toLowerCase().includes(q)) ||
        c.title?.toLowerCase().includes(q) ||
        c.subtitle?.toLowerCase().includes(q),
    );
    setSearchQuery(tag);
    setSearchResults(results);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setSearchResults([]);
  };

  // Find all the tags for searching
  let allTags = [
    ...new Set(
      courses
        ?.map((i) => {
          return i.tags;
        })
        .flat()
        .sort(),
    ),
  ];

  return (
    <div className="testred" style={{ backgroundColor: "red" }}>
      <Helmet>
        <link rel="canonical" href="https://www.iclimbtrees.com/courses" />
      </Helmet>
      <Header />
      <main>
        <Hero ref={heroRef} onSearch={handleSearch} allTags={allTags} />

        <div id="courses" className="courses-container">
          <SearchResults
            query={searchQuery}
            results={searchResults}
            onClear={handleClearSearch}
          />

          <CourseList
            id="continue"
            title="Continue"
            courses={myCourses}
            type="already started"
          />

          <div className="courses-divider" />

          <CourseList
            id="machine-learning"
            title="Machine Learning"
            courses={MLCourses}
          />

          <div className="courses-divider" />

          <CourseList
            id="probability"
            title="Probability"
            courses={ProbCourses}
          />

          <div className="courses-divider" />

          <CourseList
            id="optimization"
            title="Optimization"
            courses={OptimizationCourses}
          />
        </div>
      </main>

      <FAQ onOpenVideo={() => heroRef.current?.openVideo()} />
      <Stats />
      <Newsletter />
      <Footer />
      {user?.result?.admin && (
        <>
          <div className="choose-admin-tools">
            {!newCourseFormVisible && (
              <button
                onClick={() => setNewCourseFormVisible(true)}
                className="course-page__start-btn"
                style={{ backgroundColor: "purple" }}
              >
                Add new course
              </button>
            )}
            <button
              onClick={() => navigate(`/editsupport/`)}
              className="course-page__start-btn"
              style={{ backgroundColor: "purple" }}
            >
              Edit Support Items
            </button>
          </div>
        </>
      )}

      {user?.result?.admin && newCourseFormVisible && (
        <AddEditCourse onClose={() => setNewCourseFormVisible(false)} />
      )}
    </div>
  );
}
